import React from "react";

const Resume = () => {
  return (
    <div className="resume-container">
      <h1>Resume</h1>
      <p>
        <a
          href="https://drive.google.com/file/d/1T83PVO8_xDVAK9raKhUdP5ZTU-cpFYcb/view?usp=drive_link"
          target="blank"
          rel="noopener noreferrer"
        >
          You can View or Download My Resume using this link
        </a>
      </p>
    </div>
  );
};

export default Resume;
